import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function History() {
    const { historyItems } = useAppState()

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    useEffect(() => {
        nostojs(api => api.createRecommendationRequest()
        .setElements(['ns-autocomplete-rec'])
        .load()
)
    })

    return (
        <div class="ns-autocomplete ns-absolute ns-background-white">
            <div class="predictive-search__layout wrapper">
                <div class="ns-pop-searches">
                    <div class="ns-autocomplete-header">Popular Searches</div>
                    <div class="predictive-search__item" id="predictive-search-option-collection-1" role="option" aria-selected="false">
                         <a class="predictive-search__link" href="https://moussy-global.com/collections/jeans" tabindex="-1">Jeans</a>
                      </div>
                      <div class="predictive-search__item" id="predictive-search-option-collection-1" role="option" aria-selected="false">
                         <a class="predictive-search__link" href="https://moussy-global.com/collections/shorts" tabindex="-1">Shorts</a>
                      </div>
                      <div class="predictive-search__item" id="predictive-search-option-collection-1" role="option" aria-selected="false">
                         <a class="predictive-search__link" href="https://moussy-global.com/collections/bags" tabindex="-1">Bags</a>
                      </div>
                      <div class="predictive-search__item" id="predictive-search-option-collection-1" role="option" aria-selected="false">
                         <a class="predictive-search__link" href="https://moussy-global.com/collections/skirts" tabindex="-1">Skirts</a>
                      </div>
                </div>
                <div class="ns-pop-rec">
                    <div class="ns-autocomplete-header">Popular Searches</div>
                    <div class="nosto_element" id="ns-autocomplete-rec"></div>
                </div>
            </div>
        </div>
    )
}
